import React from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash.get';
import { connect } from 'react-redux';
import AdCaller from './adCaller';

// Will be removed JARVIS PAGE MOVEMENT
// tw - topband web | tm - topband mweb

const defaultTopAd = {
  tw: '/7176/TOI/TOI_ROS_TOP_Strip_1000x60',
  tm: '/7176/TOI_MWeb/TOI_Mweb_Fixed/TOI_Mweb_Fixed_ATF',
  ws: [[1000, 60]],
  ms: [[320, 50]],
};
// Will be removed JARVIS PAGE MOVEMENT
const topbandadCode = scn => {
  switch (scn) {
    case 'astrology':
      return {
        tw: defaultTopAd.tw,
        tm:
          '/7176/TOI_Mweb_Astrology/TOI_Mweb_Astro_ROS/TOI_Mweb_Astrology_Fixed_ATF',
      };
    case 'sports':
      return {
        tw: '/7176/TOI/TOI_Sports/TOI_Sports_TopBand',
        tm: '/7176/TOI_MWeb/TOI_MWeb_Sports/TOI_Mweb_Sports_TopBand',
        ws: [[1000, 60], [1000, 50]],
      };
    default:
      return defaultTopAd;
  }
};
// End - Will be removed JARVIS PAGE MOVEMENT
const JarvisAdUnit = props => {
  const { jarvisConfig, isWapView, type, adCodeInfo, adConfig } = props;
  let currentAdConf = {};
  if (jarvisConfig && typeof jarvisConfig === 'object' && jarvisConfig[type]) {
    currentAdConf = jarvisConfig[type];
  }

  const campaignActive = currentAdConf?.isAdActive || 0;
  const adCode = topbandadCode(currentAdConf?.scn);
  const mwebSize = adCode.ms || defaultTopAd.ms;
  const webSize = adCode.ws || defaultTopAd.ws;

  // it will be replace by jarvis ad units in phase 2 | JARVIS PAGE MOVEMENT
  const allAdCodeInfo = {
    topBand: {
      name: 'topBand',
      adCode: isWapView ? adCode.tm : adCode.tw,
      tn: 'ad',
      adType: 'dfp',
      divId: 'div-gpt-ad-topband-1628142867492-0',
      size: isWapView ? mwebSize : webSize,
      checkJarvisIsAdActive: 'topBand',
      addclass: 'isAdActive',
    },
  };

  const currentAdInfo = adCodeInfo || allAdCodeInfo[type] || {};
  let adDivCss = '';
  if (campaignActive) {
    adDivCss = isWapView ? ' isAdActive phShimmer' : ' isAdActive';
  }
  if (adConfig) {
    currentAdInfo.adCode = adConfig.adCode;
    currentAdInfo.size = adConfig.size || currentAdInfo.size;
  }
  return (
    <AdCaller
      adWapperClass={`${type}_adwrapper${adDivCss}`}
      data={{
        ...currentAdInfo,
      }}
    />
  );
};

const mapStateToProps = state => ({
  jarvisConfig: _get(state, 'common.siteConfig.revenue', {}),
});
JarvisAdUnit.propTypes = {
  jarvisConfig: PropTypes.shape({
    topBand: PropTypes.shape({
      isAdActive: PropTypes.number,
    }),
  }),
  isWapView: PropTypes.bool,
  type: PropTypes.string,
  adCodeInfo: PropTypes.shape({}),
  adConfig: PropTypes.shape({}),
};
JarvisAdUnit.defaultProps = {
  jarvisConfig: {
    topBand: {
      isAdActive: 0,
    },
  },
  isWapView: false,
  type: '',
  adCodeInfo: undefined,
  adConfig: undefined,
};
export default connect(mapStateToProps)(JarvisAdUnit);
